module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxMCAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik04LjYyNzY4IDQuNTEwMkM5LjI5NDM1IDQuODk1MSA5LjI5NDM1IDUuODU3MzYgOC42Mjc2OSA2LjI0MjI2TDIuMDAyNjkgMTAuMDY3MkMxLjMzNjAyIDEwLjQ1MjEgMC41MDI2ODcgOS45NzA5OCAwLjUwMjY4NyA5LjIwMTE4VjEuNTUxMjlDMC41MDI2ODcgMC43ODE0ODYgMS4zMzYwMiAwLjMwMDM1OSAyLjAwMjY5IDAuNjg1MjZMOC42Mjc2OCA0LjUxMDJaIiBmaWxsPSIjNTI1MjUyIi8+DQo8L3N2Zz4NCg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/account/play.svg
// module id = 9694
// module chunks = 0